import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { NgClass, NgIf } from '@angular/common';
import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { ThemeService } from 'src/app/service/theme.service';

@Component({
  selector: 'app-accordion',
  imports: [
    NgIf,
    NgClass,
    RouterModule,
    StoryblokDirective,
    StoryblokRichTextDirective,
  ],
  animations: [
    trigger('openClose', [
      state(
        'closed',
        style({
          marginTop: '0px',
          height: '0',
          overflow: 'hidden',
          opacity: '0',
        })
      ),
      state(
        'open',
        style({
          marginTop: '40px',
          height: '*',
          overflow: 'hidden',
          opacity: '1',
        })
      ),
      transition('closed <=> open', [animate('300ms ease-in-out')]),
    ]),
  ],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
})
export class AccordionComponent implements OnInit {
  @Input() title!: string;
  @Input() body!: string;
  @Input() colour!: { color: string };
  @Input() background!: { color: string };
  @Input() _editable!: string;
  @Input() _uid!: string;
  @Input() component!: string;
  @Input() isOpen = false;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private themeService: ThemeService
  ) {
    this.themeService.themeEvents.subscribe((data) => {
      if (data.type === 'accordionOpen' && data.meta.uid !== this._uid) {
        this.isOpen = false;
      }
    });
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.themeService.accordionOpen(this._uid);
  }

  ngOnInit() {
    if (this.colour?.color) {
      this.renderer.setStyle(this.el.nativeElement, 'color', this.colour.color);
    }
    if (this.background?.color) {
      this.renderer.setStyle(
        this.el.nativeElement,
        'background',
        this.background.color
      );
    }
  }
}
